import { render, staticRenderFns } from "./HeirloomMessage.vue?vue&type=template&id=f3596f32"
import script from "./HeirloomMessage.vue?vue&type=script&lang=js"
export * from "./HeirloomMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports